// Hoisted const objects are shared memory on the server. So they
// should only be immutable primitives. Regex creation is slow, so
// we don't do it in the render function which can repeat.
const GIFT_CARD_HANDLE_REGEX = /gift-card/
const PHYSICAL_REGEX = /physical/

export const isGiftCardHandle = (productGroupHandle: string) => {
  return GIFT_CARD_HANDLE_REGEX.test(productGroupHandle)
}

export const useIsGiftCard = ({ productGroupHandle }: { productGroupHandle: string }) => {
  return GIFT_CARD_HANDLE_REGEX.test(productGroupHandle)
}

export const useIsPhysicalGiftCard = ({ productGroupHandle }: { productGroupHandle: string }) => {
  return GIFT_CARD_HANDLE_REGEX.test(productGroupHandle) && PHYSICAL_REGEX.test(productGroupHandle)
}
